import React from 'react';

export default function PrimaryButton({ children, className = '', as: Component = 'button', ...props }) {
  return (
    <Component
      className={`group relative inline-flex items-center justify-center gap-2 rounded-full bg-white text-black font-medium text-[14px] px-7 h-[46px] hover:bg-white/90 transition shadow-[0_10px_24px_rgba(255,255,255,0.15)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500/60 ${className}`}
      {...props}
    >
      {children}
      <span className="group-hover:translate-x-0.5 transition">→</span>
    </Component>
  );
}
